var map = {
	"./ar.json": [
		180,
		180
	],
	"./en.json": [
		2068,
		2068
	],
	"./es.json": [
		8871,
		8871
	],
	"./ru.json": [
		8582,
		8582
	],
	"./zh.json": [
		4801,
		4801
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1707;
module.exports = webpackAsyncContext;